<section class="hero">
  <div class="hero__inner row pad">
    <div class="hero__overlay">
      <h1 class="hero__title">
        We Power, Lead, and Grow World-Defining Live Experiences
      </h1>
      <a
        class="hero__down"
        [routerLink]="['/']"
        fragment="about"
        aria-label="Scroll to About Section"
      ></a>
    </div>
    <div class="hero__video">
      <video autoplay muted playsinline loop>
        <source src="/video.mp4" type="video/mp4" />
        Your browser does not support the video tag .
      </video>
    </div>
  </div>
</section>

<section class="about section-pad" id="about">
  <div class="row pad">
    <div class="about__inner">
      <div class="about__title text-muted">ABOUT</div>
      <p class="about__text">
        MARI is reshaping the live events landscape — delivering experiences
        that move culture globally. From sports and entertainment to art and
        lifestyle, we’re building a growing portfolio of category-defining
        events and brands that set the standard for what’s next.
      </p>
      <a class="btn" routerLink="about">LEARN MORE</a>
    </div>
  </div>
</section>

<section class="portfolio">
  <div class="portfolio__inner">
    <div class="row pad">
      <h2 class="portfolio__title">Portfolio</h2>
    </div>

    <!-- Mobile Layout -->
    <div class="portfolio__images hide-medium">
      <div class="portfolio__left">
        <a
          routerLink="/portfolio"
          [queryParams]="{ category: 'Lifestyle' }"
          class="portfolio__item portfolio__item--lifestyle"
        >
          <div class="portfolio__overlay">
            <div class="portfolio__text"><span>Lifestyle</span></div>
          </div>
          <img src="/portfolio/mobile/Lifestyle.jpg" alt="Lifestyle Image" />
        </a>
        <a
          routerLink="/portfolio"
          [queryParams]="{ category: 'Sports' }"
          class="portfolio__item portfolio__item--sports portfolio__item--portrait"
        >
          <div class="portfolio__overlay">
            <div class="portfolio__text"><span>Sports</span></div>
          </div>
          <img src="/portfolio/mobile/Sports.jpg" alt="Sports Image" />
        </a>
        <a
          routerLink="/portfolio"
          [queryParams]="{ category: 'Arts' }"
          class="portfolio__item portfolio__item--arts"
        >
          <div class="portfolio__overlay">
            <div class="portfolio__text"><span>Arts</span></div>
          </div>
          <img src="/portfolio/mobile/Arts.jpg" alt="Arts Image" />
        </a>
        <a
          routerLink="/portfolio"
          [queryParams]="{ category: 'Ticketing and Technology' }"
          class="portfolio__item portfolio__item--ticketingandtechnology portfolio__item--portrait"
        >
          <div class="portfolio__overlay">
            <div class="portfolio__text">
              <span>Ticketing and<br />Technology</span>
            </div>
          </div>
          <img src="/portfolio/mobile/Ticketing.jpg" alt="Ticketing Image" />
        </a>
        <a
          routerLink="/portfolio"
          [queryParams]="{ category: 'Collectibles' }"
          class="portfolio__item portfolio__item--collectibles"
        >
          <div class="portfolio__overlay">
            <div class="portfolio__text"><span>Collectibles</span></div>
          </div>
          <img
            src="/portfolio/mobile/Collectibles.jpg"
            alt="Collectibles Image"
          />
        </a>
      </div>
    </div>

    <!-- Desktop Layout -->
    <div class="portfolio__images hide-medium-down">
      <div class="portfolio__left">
        <a
          routerLink="/portfolio"
          [queryParams]="{ category: 'Lifestyle' }"
          class="portfolio__item portfolio__item--lifestyle"
        >
          <div class="portfolio__overlay">
            <div class="portfolio__text"><span>Lifestyle</span></div>
          </div>
          <img src="/portfolio/Lifestyle.jpg" alt="Lifestyle Image" />
        </a>
        <a
          routerLink="/portfolio"
          [queryParams]="{ category: 'Arts' }"
          class="portfolio__item portfolio__item--arts portfolio__item--portrait"
        >
          <div class="portfolio__overlay">
            <div class="portfolio__text"><span>Arts</span></div>
          </div>
          <img src="/portfolio/Arts.jpg" alt="Arts Image" />
        </a>
        <a
          routerLink="/portfolio"
          [queryParams]="{ category: 'Ticketing and Technology' }"
          class="portfolio__item portfolio__item--ticketingandtechnology"
        >
          <div class="portfolio__overlay">
            <div class="portfolio__text">
              <span>Ticketing and<br />Technology</span>
            </div>
          </div>
          <img src="/portfolio/Ticketing.jpg" alt="Ticketing Image" />
        </a>
      </div>
      <div class="portfolio__right">
        <a
          routerLink="/portfolio"
          [queryParams]="{ category: 'Sports' }"
          class="portfolio__item portfolio__item--sports portfolio__item--portrait"
        >
          <div class="portfolio__overlay">
            <div class="portfolio__text"><span>Sports</span></div>
          </div>
          <img src="/portfolio/Sports.jpg" alt="Sports Image" />
        </a>
        <a
          routerLink="/portfolio"
          [queryParams]="{ category: 'Collectibles' }"
          class="portfolio__item portfolio__item--collectibles"
        >
          <div class="portfolio__overlay">
            <div class="portfolio__text"><span>Collectibles</span></div>
          </div>
          <img src="/portfolio/Collectibles.jpg" alt="Collectibles Image" />
        </a>
      </div>
    </div>
    <a routerLink="/portfolio" class="portfolio__more btn">SEE PORTFOLIO</a>
  </div>
</section>

<section class="press section-pad">
  <div class="press__inner row pad">
    <h2 class="press__title">Press</h2>
    <div class="swiper-button-container">
      <button class="swiper-button-prev" aria-label="Previous Slide">
        <img src="/arrow-right-icon.svg" alt="Left Icon" />
      </button>
      <button class="swiper-button-next" aria-label="Next Slide">
        <img src="/arrow-right-icon.svg" alt="Right Icon" />
      </button>
    </div>
  </div>
  <div class="press__articles-container row pad">
    <div class="press__articles">
      @if (isBrowser) {
        <swiper-container
          #swiperCenters
          appInitSwiper
          id="articles"
          class="swiper"
          init="false"
          [config]="pressSwiperConfig"
        >
          @for (article of articles; track $index) {
            <swiper-slide class="swiper-slide press__article">
              <div class="press__article-inner">
                <a class="press__item" routerLink="/press/{{ article.slug }}">
                  <div class="press__date">{{ article.date }}</div>
                  <div class="press__text">{{ article.title }}</div>
                  <div class="press__description">
                    {{ article.description }}
                  </div>
                </a>
              </div>
            </swiper-slide>
          }
        </swiper-container>
      }
    </div>
  </div>

  <a routerLink="/press" class="press__more btn">READ MORE</a>
</section>

<app-contact-section></app-contact-section>
